<div class="dropdown user_profile">
  <button class="btn btn-white d-flex align-items-center dropdown-toggle" type="button" data-bs-toggle="dropdown"
    aria-expanded="false">
    <img src="assets/images/dashboard/profile-user.png" class="user-img" alt="user" width="30" height="30" />
    <span class="d-none d-md-block mx-2">{{userData?.userName || userData?.full_name}}</span>
  </button>
  <ul class="dropdown-menu w-100">
    <!-- <li><a class="dropdown-item" href="#">Profile</a></li>
    <li><a class="dropdown-item" href="#">Settings</a></li> -->
   
    @if (!isSuperAdmin) {
    <li><a class="dropdown-item" (click)="openOutOfOfficeModal()">Out of the Office</a></li>
    }
    <li><a class="dropdown-item" (click)="logout()">Logout</a></li>
  </ul>
</div>

@defer (on idle) {
  <app-out-of-office-modal [isOpen]="isOutOfOfficeModalOpen" [mode]="'simple'" (closeModal)="closeOutOfOfficeModal()">
  </app-out-of-office-modal>
}